import { render, staticRenderFns } from "./AgencyBadgeCardPreview.vue?vue&type=template&id=ddb09042&scoped=true"
import script from "./AgencyBadgeCardPreview.vue?vue&type=script&lang=js"
export * from "./AgencyBadgeCardPreview.vue?vue&type=script&lang=js"
import style0 from "./AgencyBadgeCardPreview.vue?vue&type=style&index=0&id=ddb09042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb09042",
  null
  
)

export default component.exports